import { useTranslation } from 'react-i18next'
import {
  SearchAutocomplete,
  SearchAutocompleteOption,
} from '@/components/inputs'
import { ExpenseStatuses } from '@/types'

type ExpenseDeclarationStatusMultiSelectProps = {
  value?: string
  onChange: (value: string | undefined) => void
}

export const ExpenseDeclarationStatusMultiSelect = ({
  value,
  onChange,
}: ExpenseDeclarationStatusMultiSelectProps): JSX.Element => {
  const { t } = useTranslation('expensesDeclaration')

  const options = Object.keys(ExpenseStatuses).map((key) => {
    const status = ExpenseStatuses[
      key as keyof typeof ExpenseStatuses
    ] as string

    return {
      label: t(`indicator.${status.toLowerCase()}`),
      value: status,
    } as SearchAutocompleteOption
  })

  return (
    <SearchAutocomplete
      value={value}
      onChange={onChange}
      options={options}
      placeholder={t(`placeholders.status`)}
      sort={false}
      fieldSx={{ width: 280 }}
    />
  )
}
